import React, { useEffect, useState } from "react";
import { useIntl } from 'react-intl';

// Components
import { Form } from 'Components';
// Components/controls
import Slider from 'Components/Slider';
import TagsManage from 'Modules/.common/components/TagsManage';

export const VehicleCongregation = (props) => {

    const { value, triggersRaw, triggers, onChange, formRef } = props
    const { messages } = useIntl()
    const [localLoading, setLocalLoading] = useState(true)


    useEffect(() => {
        if (!triggersRaw) {
            let entities = triggers?.map(x => { return x.entity })
            let newValues = value
            if (value.maximumUnits == undefined)
                newValues = {
                    maximumUnits: 1,
                }
            onChange(newValues, entities)
            setLocalLoading(false)

        }
    }, [triggersRaw]);

    // <---- Entity Selector Setup ---->
    const entities = [
        { id: "Landmark", label: "Landmarks" },
        { id: "All", label: "All" },
    ];

    if(localLoading) return


    return (
        <Form ref={formRef} >
            {
                value.maximumUnits != undefined &&
                <div className="form-item" style={{ padding: "20px 0" }}>
                    <label className="input-normal-label">{messages['alertsNewAlert_triggersLabel']}</label>
                    <div style={{ width: "100%" }}>
                        {
                            (!triggersRaw || triggersRaw?.length == 0) &&
                            <div className="text-danger" style={{ paddingBottom: 10 }}>
                                {messages["alertsNewAlert_triggerValidation"]}
                            </div>
                        }
                        <TagsManage
                            entities={entities}
                            value={triggersRaw || []}
                            entitySelected={entities.find(x => x.id == (triggersRaw?.find(x => x.id == "-1" && x?.name == 'All') && "All" || "Landmark"))}
                            setEntitySelected={(newSelectedEntity) => {
                                if (newSelectedEntity?.id === "All") {
                                    onChange(value, [{ id: "-1", __typename: "All", name: "All" }]);
                                } else {
                                    onChange(value, []);
                                }
                            }}
                            onChange={(selectedItems, entity) => {
                                onChange(
                                    value,
                                    selectedItems.map(selectedItem => {
                                        return { ...selectedItem, label: entity.id }
                                    })
                                )
                            }}
                            height={240}
                            mode="list"
                            onlyTags={true}
                            disableUntaggedSelection={true}
                            enableSelectAll={false}
                        />
                    </div>
                    <div style={{ width: '100%', marginTop: 10, marginBottom: 30 }}>
                        <label className="input-normal-label">
                            {messages['alert_numberOfUnitsAllowedLandmarkLabel']}
                        </label>
                        <Slider
                            min={2}
                            max={1000}
                            sliderOneColor={false}
                            showValue
                            valueLabelDisplay={'off'}
                            value={value.maximumUnits}
                            onChange={(event) => { onChange({ ...value, maximumUnits: event }, triggersRaw) }}
                        />
                    </div>
                </div>
            }
        </Form>
    );
}
